import {SkeletonBlock, TabContentItem} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const LoadingTab: FC<{name: string}> = ({name}) => {
  return (
    <TabContentItem
      name={name}
      label={<SkeletonBlock $width="100%" />}
      content={
        <>
          <ImageSkeletonBlock $width="35%" />
          <SkeletonBlock $width="20%" />
          <SkeletonBlock $width="45%" />
          <SkeletonBlock $width="45%" />
          <SkeletonBlock $width="45%" />
          <SkeletonBlock $width="20%" />
          <SkeletonBlock $width="45%" />
          <SkeletonBlock $width="45%" />
          <SkeletonBlock $width="45%" />
        </>
      }
    />
  );
};

const ImageSkeletonBlock = styled(SkeletonBlock)`
  float: right;
  height: auto;
  aspect-ratio: 3 / 4;
`;
